/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SubmitCheckoutResponse = zod
	.object({
		case_id: zod.string().describe('Created case identifier'),
		case_items: zod
			.array(
				zod
					.object({
						case_id: zod.string().describe('Case ID'),
						content_blurhash: zod.string().nullable().describe('BlurHash placeholder for image'),
						content_height: zod.number().nullable().describe('Image height in pixels'),
						content_size: zod.number().describe('Size of the content in bytes'),
						content_type: zod.string().describe('MIME type of the content'),
						content_width: zod.number().nullable().describe('Image width in pixels'),
						id: zod.string().describe('Case item ID'),
						inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
						path: zod.string().nullable().describe('Signed URL to the content'),
						type: zod.enum(['text', 'image'])
					})
					.describe('A content item within a moderation case')
			)
			.describe('List of processed content items'),
		case_status: zod.enum(['pending', 'completed', 'failed', 'processing']),
		checkout_id: zod.string().describe('Checkout identifier'),
		checkout_status: zod.enum(['open', 'closed']),
		submitted_at: zod.iso.datetime({ offset: true }).describe('Submission timestamp')
	})
	.describe('Checkout submission response');

export type SubmitCheckoutResponse = zod.input<typeof SubmitCheckoutResponse>;
export type SubmitCheckoutResponseOutput = zod.output<typeof SubmitCheckoutResponse>;
